/**
 * ISO 3166-1 countries as Search Console's country filter expects them: the alpha-3 code in
 * lower case. Generated from the iso-codes database; the labels are the ISO short names.
 *
 * The list is the full set rather than a popular subset because a property's traffic can come
 * from anywhere, and a country missing from the control would look like a country with no data.
 */
export const COUNTRIES = [
    { label: 'Afghanistan', value: 'afg' },
    { label: 'Albania', value: 'alb' },
    { label: 'Algeria', value: 'dza' },
    { label: 'American Samoa', value: 'asm' },
    { label: 'Andorra', value: 'and' },
    { label: 'Angola', value: 'ago' },
    { label: 'Anguilla', value: 'aia' },
    { label: 'Antarctica', value: 'ata' },
    { label: 'Antigua and Barbuda', value: 'atg' },
    { label: 'Argentina', value: 'arg' },
    { label: 'Armenia', value: 'arm' },
    { label: 'Aruba', value: 'abw' },
    { label: 'Australia', value: 'aus' },
    { label: 'Austria', value: 'aut' },
    { label: 'Azerbaijan', value: 'aze' },
    { label: 'Bahamas', value: 'bhs' },
    { label: 'Bahrain', value: 'bhr' },
    { label: 'Bangladesh', value: 'bgd' },
    { label: 'Barbados', value: 'brb' },
    { label: 'Belarus', value: 'blr' },
    { label: 'Belgium', value: 'bel' },
    { label: 'Belize', value: 'blz' },
    { label: 'Benin', value: 'ben' },
    { label: 'Bermuda', value: 'bmu' },
    { label: 'Bhutan', value: 'btn' },
    { label: 'Bolivia, Plurinational State of', value: 'bol' },
    { label: 'Bonaire, Sint Eustatius and Saba', value: 'bes' },
    { label: 'Bosnia and Herzegovina', value: 'bih' },
    { label: 'Botswana', value: 'bwa' },
    { label: 'Bouvet Island', value: 'bvt' },
    { label: 'Brazil', value: 'bra' },
    { label: 'British Indian Ocean Territory', value: 'iot' },
    { label: 'Brunei Darussalam', value: 'brn' },
    { label: 'Bulgaria', value: 'bgr' },
    { label: 'Burkina Faso', value: 'bfa' },
    { label: 'Burundi', value: 'bdi' },
    { label: 'Cabo Verde', value: 'cpv' },
    { label: 'Cambodia', value: 'khm' },
    { label: 'Cameroon', value: 'cmr' },
    { label: 'Canada', value: 'can' },
    { label: 'Cayman Islands', value: 'cym' },
    { label: 'Central African Republic', value: 'caf' },
    { label: 'Chad', value: 'tcd' },
    { label: 'Chile', value: 'chl' },
    { label: 'China', value: 'chn' },
    { label: 'Christmas Island', value: 'cxr' },
    { label: 'Cocos (Keeling) Islands', value: 'cck' },
    { label: 'Colombia', value: 'col' },
    { label: 'Comoros', value: 'com' },
    { label: 'Congo', value: 'cog' },
    { label: 'Congo, The Democratic Republic of the', value: 'cod' },
    { label: 'Cook Islands', value: 'cok' },
    { label: 'Costa Rica', value: 'cri' },
    { label: 'Croatia', value: 'hrv' },
    { label: 'Cuba', value: 'cub' },
    { label: 'Curaçao', value: 'cuw' },
    { label: 'Cyprus', value: 'cyp' },
    { label: 'Czechia', value: 'cze' },
    { label: "Côte d'Ivoire", value: 'civ' },
    { label: 'Denmark', value: 'dnk' },
    { label: 'Djibouti', value: 'dji' },
    { label: 'Dominica', value: 'dma' },
    { label: 'Dominican Republic', value: 'dom' },
    { label: 'Ecuador', value: 'ecu' },
    { label: 'Egypt', value: 'egy' },
    { label: 'El Salvador', value: 'slv' },
    { label: 'Equatorial Guinea', value: 'gnq' },
    { label: 'Eritrea', value: 'eri' },
    { label: 'Estonia', value: 'est' },
    { label: 'Eswatini', value: 'swz' },
    { label: 'Ethiopia', value: 'eth' },
    { label: 'Falkland Islands (Malvinas)', value: 'flk' },
    { label: 'Faroe Islands', value: 'fro' },
    { label: 'Fiji', value: 'fji' },
    { label: 'Finland', value: 'fin' },
    { label: 'France', value: 'fra' },
    { label: 'French Guiana', value: 'guf' },
    { label: 'French Polynesia', value: 'pyf' },
    { label: 'French Southern Territories', value: 'atf' },
    { label: 'Gabon', value: 'gab' },
    { label: 'Gambia', value: 'gmb' },
    { label: 'Georgia', value: 'geo' },
    { label: 'Germany', value: 'deu' },
    { label: 'Ghana', value: 'gha' },
    { label: 'Gibraltar', value: 'gib' },
    { label: 'Greece', value: 'grc' },
    { label: 'Greenland', value: 'grl' },
    { label: 'Grenada', value: 'grd' },
    { label: 'Guadeloupe', value: 'glp' },
    { label: 'Guam', value: 'gum' },
    { label: 'Guatemala', value: 'gtm' },
    { label: 'Guernsey', value: 'ggy' },
    { label: 'Guinea', value: 'gin' },
    { label: 'Guinea-Bissau', value: 'gnb' },
    { label: 'Guyana', value: 'guy' },
    { label: 'Haiti', value: 'hti' },
    { label: 'Heard Island and McDonald Islands', value: 'hmd' },
    { label: 'Holy See (Vatican City State)', value: 'vat' },
    { label: 'Honduras', value: 'hnd' },
    { label: 'Hong Kong', value: 'hkg' },
    { label: 'Hungary', value: 'hun' },
    { label: 'Iceland', value: 'isl' },
    { label: 'India', value: 'ind' },
    { label: 'Indonesia', value: 'idn' },
    { label: 'Iran, Islamic Republic of', value: 'irn' },
    { label: 'Iraq', value: 'irq' },
    { label: 'Ireland', value: 'irl' },
    { label: 'Isle of Man', value: 'imn' },
    { label: 'Israel', value: 'isr' },
    { label: 'Italy', value: 'ita' },
    { label: 'Jamaica', value: 'jam' },
    { label: 'Japan', value: 'jpn' },
    { label: 'Jersey', value: 'jey' },
    { label: 'Jordan', value: 'jor' },
    { label: 'Kazakhstan', value: 'kaz' },
    { label: 'Kenya', value: 'ken' },
    { label: 'Kiribati', value: 'kir' },
    { label: "Korea, Democratic People's Republic of", value: 'prk' },
    { label: 'Korea, Republic of', value: 'kor' },
    { label: 'Kuwait', value: 'kwt' },
    { label: 'Kyrgyzstan', value: 'kgz' },
    { label: "Lao People's Democratic Republic", value: 'lao' },
    { label: 'Latvia', value: 'lva' },
    { label: 'Lebanon', value: 'lbn' },
    { label: 'Lesotho', value: 'lso' },
    { label: 'Liberia', value: 'lbr' },
    { label: 'Libya', value: 'lby' },
    { label: 'Liechtenstein', value: 'lie' },
    { label: 'Lithuania', value: 'ltu' },
    { label: 'Luxembourg', value: 'lux' },
    { label: 'Macao', value: 'mac' },
    { label: 'Madagascar', value: 'mdg' },
    { label: 'Malawi', value: 'mwi' },
    { label: 'Malaysia', value: 'mys' },
    { label: 'Maldives', value: 'mdv' },
    { label: 'Mali', value: 'mli' },
    { label: 'Malta', value: 'mlt' },
    { label: 'Marshall Islands', value: 'mhl' },
    { label: 'Martinique', value: 'mtq' },
    { label: 'Mauritania', value: 'mrt' },
    { label: 'Mauritius', value: 'mus' },
    { label: 'Mayotte', value: 'myt' },
    { label: 'Mexico', value: 'mex' },
    { label: 'Micronesia, Federated States of', value: 'fsm' },
    { label: 'Moldova, Republic of', value: 'mda' },
    { label: 'Monaco', value: 'mco' },
    { label: 'Mongolia', value: 'mng' },
    { label: 'Montenegro', value: 'mne' },
    { label: 'Montserrat', value: 'msr' },
    { label: 'Morocco', value: 'mar' },
    { label: 'Mozambique', value: 'moz' },
    { label: 'Myanmar', value: 'mmr' },
    { label: 'Namibia', value: 'nam' },
    { label: 'Nauru', value: 'nru' },
    { label: 'Nepal', value: 'npl' },
    { label: 'Netherlands', value: 'nld' },
    { label: 'New Caledonia', value: 'ncl' },
    { label: 'New Zealand', value: 'nzl' },
    { label: 'Nicaragua', value: 'nic' },
    { label: 'Niger', value: 'ner' },
    { label: 'Nigeria', value: 'nga' },
    { label: 'Niue', value: 'niu' },
    { label: 'Norfolk Island', value: 'nfk' },
    { label: 'North Macedonia', value: 'mkd' },
    { label: 'Northern Mariana Islands', value: 'mnp' },
    { label: 'Norway', value: 'nor' },
    { label: 'Oman', value: 'omn' },
    { label: 'Pakistan', value: 'pak' },
    { label: 'Palau', value: 'plw' },
    { label: 'Palestine, State of', value: 'pse' },
    { label: 'Panama', value: 'pan' },
    { label: 'Papua New Guinea', value: 'png' },
    { label: 'Paraguay', value: 'pry' },
    { label: 'Peru', value: 'per' },
    { label: 'Philippines', value: 'phl' },
    { label: 'Pitcairn', value: 'pcn' },
    { label: 'Poland', value: 'pol' },
    { label: 'Portugal', value: 'prt' },
    { label: 'Puerto Rico', value: 'pri' },
    { label: 'Qatar', value: 'qat' },
    { label: 'Romania', value: 'rou' },
    { label: 'Russian Federation', value: 'rus' },
    { label: 'Rwanda', value: 'rwa' },
    { label: 'Réunion', value: 'reu' },
    { label: 'Saint Barthélemy', value: 'blm' },
    { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'shn' },
    { label: 'Saint Kitts and Nevis', value: 'kna' },
    { label: 'Saint Lucia', value: 'lca' },
    { label: 'Saint Martin (French part)', value: 'maf' },
    { label: 'Saint Pierre and Miquelon', value: 'spm' },
    { label: 'Saint Vincent and the Grenadines', value: 'vct' },
    { label: 'Samoa', value: 'wsm' },
    { label: 'San Marino', value: 'smr' },
    { label: 'Sao Tome and Principe', value: 'stp' },
    { label: 'Saudi Arabia', value: 'sau' },
    { label: 'Senegal', value: 'sen' },
    { label: 'Serbia', value: 'srb' },
    { label: 'Seychelles', value: 'syc' },
    { label: 'Sierra Leone', value: 'sle' },
    { label: 'Singapore', value: 'sgp' },
    { label: 'Sint Maarten (Dutch part)', value: 'sxm' },
    { label: 'Slovakia', value: 'svk' },
    { label: 'Slovenia', value: 'svn' },
    { label: 'Solomon Islands', value: 'slb' },
    { label: 'Somalia', value: 'som' },
    { label: 'South Africa', value: 'zaf' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'sgs' },
    { label: 'South Sudan', value: 'ssd' },
    { label: 'Spain', value: 'esp' },
    { label: 'Sri Lanka', value: 'lka' },
    { label: 'Sudan', value: 'sdn' },
    { label: 'Suriname', value: 'sur' },
    { label: 'Svalbard and Jan Mayen', value: 'sjm' },
    { label: 'Sweden', value: 'swe' },
    { label: 'Switzerland', value: 'che' },
    { label: 'Syrian Arab Republic', value: 'syr' },
    { label: 'Taiwan, Province of China', value: 'twn' },
    { label: 'Tajikistan', value: 'tjk' },
    { label: 'Tanzania, United Republic of', value: 'tza' },
    { label: 'Thailand', value: 'tha' },
    { label: 'Timor-Leste', value: 'tls' },
    { label: 'Togo', value: 'tgo' },
    { label: 'Tokelau', value: 'tkl' },
    { label: 'Tonga', value: 'ton' },
    { label: 'Trinidad and Tobago', value: 'tto' },
    { label: 'Tunisia', value: 'tun' },
    { label: 'Turkey', value: 'tur' },
    { label: 'Turkmenistan', value: 'tkm' },
    { label: 'Turks and Caicos Islands', value: 'tca' },
    { label: 'Tuvalu', value: 'tuv' },
    { label: 'Uganda', value: 'uga' },
    { label: 'Ukraine', value: 'ukr' },
    { label: 'United Arab Emirates', value: 'are' },
    { label: 'United Kingdom', value: 'gbr' },
    { label: 'United States', value: 'usa' },
    { label: 'United States Minor Outlying Islands', value: 'umi' },
    { label: 'Uruguay', value: 'ury' },
    { label: 'Uzbekistan', value: 'uzb' },
    { label: 'Vanuatu', value: 'vut' },
    { label: 'Venezuela, Bolivarian Republic of', value: 'ven' },
    { label: 'Viet Nam', value: 'vnm' },
    { label: 'Virgin Islands, British', value: 'vgb' },
    { label: 'Virgin Islands, U.S.', value: 'vir' },
    { label: 'Wallis and Futuna', value: 'wlf' },
    { label: 'Western Sahara', value: 'esh' },
    { label: 'Yemen', value: 'yem' },
    { label: 'Zambia', value: 'zmb' },
    { label: 'Zimbabwe', value: 'zwe' },
    { label: 'Åland Islands', value: 'ala' },
];
